import { render, staticRenderFns } from "./CartaoDeJob.vue?vue&type=template&id=665d90cb&scoped=true"
import script from "./CartaoDeJob.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeJob.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeJob.vue?vue&type=style&index=0&id=665d90cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d90cb",
  null
  
)

export default component.exports